import CountryPageRenderer from '../components/CountryPageRenderer';
import turkeyData from '../data/country-pages/turkey';

export default function TurkeyCountryPage() {
  return <CountryPageRenderer data={turkeyData} />;
}
